import { Chatbot } from "./../../../Models";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const LOCAL_STORAGE_KEY = "selectedProducts";

// ✅ Load selected products from local storage
const loadSelectedProducts = () => {
  try {
    const storedProducts = localStorage.getItem(LOCAL_STORAGE_KEY);
    return storedProducts ? JSON.parse(storedProducts) : { selectedType: "", products: [] };
  } catch (error) {
    console.error("Error loading selected products from localStorage", error);
    return { selectedType: "", products: [] };
  }
};

const INITIAL_STATE: any = {
  bot_id: "",
  selectedProducts: loadSelectedProducts(), // ✅ Initialize with local storage
};

const sliceBotId = createSlice({
  name: "currentBot",
  initialState: INITIAL_STATE,
  reducers: {
    ChangeSelectedBot(state, { payload }: PayloadAction<Chatbot>) {
      return { ...state, ...payload };
    },
    UpdateSelectedProducts(state, { payload }: PayloadAction<{ selectedType: string; products: any[] }>) {
      state.selectedProducts = payload; // ✅ Update Redux state
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(payload)); // ✅ Save to local storage
    },
    ResetBotState(state) {
      state.selectedProducts = { selectedType: "", products: [] }; // Reset selected products
      localStorage.removeItem(LOCAL_STORAGE_KEY); // ✅ Clear local storage
    },
  },
});

export default sliceBotId.reducer;
export const { ChangeSelectedBot, UpdateSelectedProducts , ResetBotState} = sliceBotId.actions;

// ✅ Selectors
export const useCurrentBot = (state: any) => {
  return state.userData.dashboardData.currentBot as Chatbot;
};

export const useSelectedProducts = (state: any) => {
  return state.userData.dashboardData.currentBot.selectedProducts;
};
